import { BcAntenatalRadioTextboxField } from "../BcAntenatalRadioTextboxField";

class BritishColumbiaObstetricalFileLifeStyleSocialConcerns {
    public DietNutrition: BcAntenatalRadioTextboxField;
    public Exercise: BcAntenatalRadioTextboxField;
    public Financial: BcAntenatalRadioTextboxField;
    public HousingFoodSecurity: BcAntenatalRadioTextboxField;
    public Transportation: BcAntenatalRadioTextboxField;
    public Safety: BcAntenatalRadioTextboxField;
    public HasGenderBasedViolence?: boolean;
    public HasGenderBasedViolenceFromThePartner: boolean;
    public HasGenderBasedViolenceFromNonPartner: boolean;
    public RelationshipsSupport: BcAntenatalRadioTextboxField;
    public Other: BcAntenatalRadioTextboxField;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileLifeStyleSocialConcerns>) {
        Object.assign(this, fields);
        this.DietNutrition = new BcAntenatalRadioTextboxField(fields?.DietNutrition);
        this.Exercise = new BcAntenatalRadioTextboxField(fields?.Exercise);
        this.Financial = new BcAntenatalRadioTextboxField(fields?.Financial);
        this.HousingFoodSecurity = new BcAntenatalRadioTextboxField(fields?.HousingFoodSecurity);
        this.Transportation = new BcAntenatalRadioTextboxField(fields?.Transportation);
        this.Safety = new BcAntenatalRadioTextboxField(fields?.Safety);
        this.RelationshipsSupport = new BcAntenatalRadioTextboxField(fields?.RelationshipsSupport);
        this.Other = new BcAntenatalRadioTextboxField(fields?.Other);
    }

    public setEmptyFieldsAsNo(): void {
        this.DietNutrition.Value ??= false;
        this.Exercise.Value ??= false;
        this.Financial.Value ??= false;
        this.HousingFoodSecurity.Value ??= false;
        this.Transportation.Value ??= false;
        this.Safety.Value ??= false;
        this.HasGenderBasedViolence ??= false;
        this.RelationshipsSupport.Value ??= false;
        this.Other.Value ??= false;
    }
}

export { BritishColumbiaObstetricalFileLifeStyleSocialConcerns };
